import BaseOrderService from "@/modules/delivery/core/services/BaseOrderService";

class LocationService extends BaseOrderService {

    constructor(order, settings) {
       super(order, settings);
       this.className = 'LocationModel';
    }

    setLocation({localityFilter, address, floor, apartment, latitude, longitude, country, province, locality}){
        this.order.location.localityFilter = localityFilter;
        this.order.location.address = address;
        this.order.location.floor = floor;
        this.order.location.apartment = apartment;
        this.order.location.latitude = latitude;
        this.order.location.longitude = longitude;
        this.order.location.country = country;
        this.order.location.province = province;
        this.order.location.locality = locality;
        this.order.location.postalCode = '';

    }

    clear(){
       this.order.location.localityFilter = '';
       this.order.location.address = '';
       this.order.location.floor = '';
       this.order.location.apartment = '';
       this.order.location.latitude = '';
       this.order.location.longitude = '';
       this.order.location.country = '';
       this.order.location.province = '';
       this.order.location.locality = '';
       this.order.location.postalCode = '';
    }
}

export default LocationService;
